
import {TWO_PI, SPI} from '../constants/values';
import sign from './sign';

export default function(x) {
  return (Math.abs(x) <= SPI) ? x : (x - (sign(x) * TWO_PI));
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/proj4/lib/common/adjust_lon.js
// module id = 6
// module chunks = 0